import { useCallback } from "react";
import { axiosStructurePartnerWithoutInterceptor } from "./axios";

export interface ICreateStructurePartnerBody {
  name: string;
  notDomiciled: boolean;
  place?: string;
  website?: string;
  comment?: string;
  privileged: boolean;
  enableFup: boolean;
}

export interface ICreateStructurePartnerBodyResponse {
  _id: string;
}

export const useCreateStructurePartner = () => {
  const [state, execute, cancel] = axiosStructurePartnerWithoutInterceptor<
    ICreateStructurePartnerBodyResponse,
    ICreateStructurePartnerBody
  >(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: ICreateStructurePartnerBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
